import React from 'react';
import { Card, Form, Row, Col } from 'react-bootstrap';

const MetaSection = ({ data, onUpdate }) => {
  const handleChange = (field, value) => {
    onUpdate({ ...data, [field]: value });
  };

  return (
    <Card className="mb-4 shadow">
      <Card.Header className="bg-neutral-gray text-dark">
        <h5 className="mb-0 text-dark">SEO Meta Information</h5>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col md={12}>
            <Form.Group className="mb-3">
              <Form.Label>Meta Title</Form.Label>
              <Form.Control
                type="text"
                value={data.title}
                onChange={(e) => handleChange('title', e.target.value)}
                placeholder="Enter page meta title"
                maxLength={60}
              />
              <Form.Text className="text-muted">
                Recommended length: 50-60 characters ({data.title?.length || 0}/60)
              </Form.Text>
            </Form.Group>
          </Col>
          <Col md={12}>
            <Form.Group className="mb-3">
              <Form.Label>Meta Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={data.description}
                onChange={(e) => handleChange('description', e.target.value)}
                placeholder="Enter page meta description"
                maxLength={160}
              />
              <Form.Text className="text-muted">
                Recommended length: 120-160 characters ({data.description?.length || 0}/160)
              </Form.Text>
            </Form.Group>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default MetaSection;
